import {
  useCreateDocumentMutation,
  useUploadFileMutation
} from 'app/features/shared/api';
import React from 'react';
import Compressor from 'compressorjs';

const useUploadFile = () => {
  const [uploadedFiles] = React.useState([]);
  const [mutate, result] = useUploadFileMutation();
  const [mutateDocuments] = useCreateDocumentMutation();

  const compressImageFile = async (file: File): Promise<File | Blob> => {
    return new Promise((resolve) => {
      new Compressor(file, {
        quality: 0.6,
        maxWidth: 1024,
        maxHeight: 1024,
        convertSize: 1024 * 1024,
        convertTypes: ['image/jpeg', 'image/png', 'image/webp'],
        success: (compressedFile) => {
          resolve(compressedFile);
        }
      });
    });
  };
  const upload = async (file: File, path: string | number) => {
    try {
      const formData = new FormData();
      let willUploadFile: File | Blob = file;
      if (file.type.includes('image')) {
        //Image File
        willUploadFile = await compressImageFile(file);
        formData.append('file', willUploadFile, file.name);
      } else {
        formData.append('file', file, file.name);
      }
      const response: any = await mutate(formData).unwrap();
      const { data } = response;
      const documents = Array.isArray(data) ? data : [data];
      const params: any = {
        documentLists: documents.map((uploaded) => {
          return {
            fileSize: willUploadFile.size,
            filePath: path,
            fileName: uploaded.name.split('/')[1],
            mineType: uploaded.mineType
          };
        })
      };
      const createdDocument = await mutateDocuments(params).unwrap();
      return {
        ...createdDocument.data[0],
        url: data[0].url
      };
    } catch (error) {
      throw new Error('Uploaded Failed');
    }
  };

  const uploadFile = async (file: File | File[], path: string) => {
    try {
      const willUploaded: any[] = Array.isArray(file) ? file : [file];
      const result = await willUploaded.reduce(
        async (acc: Promise<any[]>, current: File) => {
          const result = await acc;
          const document = await upload(current, path);
          result.push(document);
          return Promise.resolve(result);
        },
        Promise.resolve<any[]>([])
      );
      return result;
    } catch (error) {
      console.error('uploadFile', error);
    }
  };

  return {
    uploadFile,
    uploadedFiles,
    ...result
  } as typeof result & {
    uploadFile: (file: File | File[], path: string | string[]) => Promise<any>;
    uploadedFiles: Array<any>;
  };
};

export default useUploadFile;
